<template>
  <div class="store-cart-wrap">
    <div class="content-wrap">
      <div class="my-breadcrumb">
        <span>我的位置：</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>我的购物车</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="cart-card">
        <div class="my-step">
          <div class="step-icon" :class="[step >= 1 ? 'step-icon-sel' : '']">1</div>
          <p class="step-name">我的购物车</p>
          <img src="~@/assets/images/step_next_icon.png" class="step-arrow" alt="">
          <div class="step-icon" :class="[step >= 2 ? 'step-icon-sel' : '']">2</div>
          <p class="step-name">核对下单</p>
          <img src="~@/assets/images/step_next_icon.png" class="step-arrow" alt="">
          <div class="step-icon">3</div>
          <p class="step-name">支付订单</p>
        </div>
        <div class="step1" v-if="step == 1">
          <div class="table-wrap">
            <el-table v-if="cartList.length > 0" :data="cartList" v-loading="loading" element-loading-text="给我一点时间"
              :empty-text="emptyText" border fit highlight-current-row ref="multipleTable"
              @selection-change="handleSelectionChange">
              <el-table-column type="selection" align="center" width="55"></el-table-column>
              <el-table-column label="货号" align="center" minWidth="150" prop="no">
              </el-table-column>
              <el-table-column label="商品名称" align="center" minWidth="150" prop="name">
              </el-table-column>
              <el-table-column label="品牌" align="center" minWidth="150">
                <template slot-scope="{row}">
                  <span>{{ row.brand_name || '--' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="数量（件）" align="center" width="100" prop="num">
              </el-table-column>
              <el-table-column label="单价（元）" align="center" minWidth="150" prop="price">
                <template slot-scope="scope">
                  <span>{{ formatPrice(scope.row.price * parseFloat(scope.row.discount) / 10) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="运费" align="center" width="120">
                <template slot-scope="scope">
                  <span class="price">{{ formatPrice(scope.row.express_fee) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="总价（元）" align="center" minWidth="100">
                <template slot-scope="scope">
                  <span class="price">{{ (formatPrice(((parseFloat(scope.row.price) * parseFloat(scope.row.discount) /
            10) + parseFloat(scope.row.express_fee))
            *
            parseInt(scope.row.num))) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" minWidth="100" v-if="!productId">
                <template slot-scope="{row}">
                  <el-link :underline="false" @click="handleDelete(row)">删除</el-link>
                </template>
              </el-table-column>
            </el-table>
            <div class="empty" v-if="cartList.length == 0">
              <img src="~@/assets/images/cart_empty.png" alt="">
            </div>
          </div>
          <div class="total-wrap">
            <p>
              <span>已选商品<i>{{ multipleSelection.length || 0 }}</i>件</span>
              <span>合计：</span>
              <i>￥</i><span class="price">{{ orderAmount }}</span>
              <el-button class="my-btn" @click="goOrder">去下单</el-button>
            </p>
          </div>
          <div class="order-tip-card">
            <div class="title">下单须知</div>
            <div class="tip" v-html="content">

            </div>
          </div>
        </div>
        <div class="step2" v-if="step == 2">
          <div class="my-form">
            <div class="address">
              <div class="title">确认收货地址</div>
              <div class="address-list">
                <el-radio-group v-model="addressId">
                  <el-radio class="item" :label="item.id" v-for="(item, index) in addressList" :key="item.id">
                    {{ item.province }} {{ item.city }} {{ item.district }} {{ item.detail }} （{{ item.recipient_name }}
                    收）{{
            item.recipient_phone
          }}
                  </el-radio>
                </el-radio-group>
              </div>
              <div class="addAddress" @click="showAddAddressForm = true">添加收货地址</div>
            </div>
            <div style="clear: both;"></div>
          </div>
          <div class="order-table">
            <div class="title">确认订单信息</div>
            <div class="table-wrap">
              <el-table :data="orderList" v-loading="loading" element-loading-text="给我一点时间" :empty-text="emptyText"
                border fit highlight-current-row>
                <el-table-column label="货号" align="center" minWidth="150" prop="no">
                </el-table-column>
                <el-table-column label="产品名称" align="center" minWidth="150" prop="name">
                </el-table-column>
                <el-table-column label="品牌" align="center" minWidth="150">
                  <template slot-scope="{row}">
                    <span>{{ row.brand_name || '--' }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="数量（件）" align="center" minWidth="100" prop="num">
                </el-table-column>
                <el-table-column label="单价（元）" align="center" minWidth="100" prop="price">
                  <template slot-scope="scope">
                    <span>{{ formatPrice(scope.row.price * parseFloat(scope.row.discount) / 10) }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="运费" align="center" width="120">
                  <template slot-scope="scope">
                    <span class="price">{{ formatPrice(scope.row.express_fee) }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="总价（元）" align="center" minWidth="100">
                  <template slot-scope="scope">
                    <span class="price">{{ (formatPrice(((parseFloat(scope.row.price) * parseFloat(scope.row.discount) /
            10)
            +
            parseFloat(scope.row.express_fee))
            *
            parseInt(scope.row.num))) }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="action-btn">
            <el-button class="my-btn per-btn" @click="step--">返回上一步</el-button>
            <el-button class="my-btn submit-btn" @click="handleAddOrder">提交订单</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 新建地址 -->
    <add-address :visible.sync="showAddAddressForm" @getList="getAddressList" />
  </div>
</template>

<script>
import { getIndex } from "@/api/index";
import { getAllAddressList } from "@/api/address";
import { getAllCartList, deleteCart } from "@/api/cart";
import { addOrder, getOrderPreview } from "@/api/order";
import { getPageDetail } from "@/api/page";
import AddAddress from "../user/components/addAddress"
export default {
  name: "StoreOrderAdd",
  components: {
    AddAddress
  },
  data() {
    return {
      showAddAddressForm: false,
      addressList: [],
      loading: true,
      emptyText: '暂无数据',
      orderId: 0,
      order: {},
      addressId: 0,
      step: 1,
      cartList: [],
      orderList: [],
      content: null,
      multipleSelection: [],
      group: 'store',
      model: 'store',
    };
  },
  computed: {
    orderAmount() {
      let amount = 0;
      const checkArr = this.multipleSelection.map(item => item.id)
      this.cartList.forEach(item => {
        if (checkArr.includes(item.id)) {
          amount += ((parseFloat(item.price) * parseFloat(item.discount) / 10) + parseFloat(item.express_fee)) * parseInt(item.num)
        }
      });
      return parseFloat(amount).toFixed(2)
    }
  },
  created() {
    this.formatPrice = this.utils.formatPrice
    this.productId = this.$route.query.id;
    if (this.productId) {
      this.getOrderPreview()
    } else {
      this.getAllCartList()
    }
    this.getPageDetail()
    this.getAddressList()
  },
  methods: {
    getOrderPreview() {
      getOrderPreview({ product_id: this.productId }).then(res => {
        this.cartList = res.data.productList
        this.$nextTick(() => {
          res.data.productList.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        })

      }).catch((err) => {

      });
    },
    goOrder() {
      if (this.multipleSelection.length == 0) {
        this.$message.error('请选择商品')
        return;
      }
      console.log(this.multipleSelection)
      this.orderList = this.multipleSelection
      this.step++
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },
    getPageDetail() {
      getPageDetail({ alias: 'order' }).then(res => {
        this.content = res.data.content
      }).catch((err) => {

      });
    },
    // 提交订单
    handleAddOrder() {
      // 验证form表单
      if (!this.addressId) {
        this.$message.error('请选择收货地址!');
        return false;
      }
      if (this.multipleSelection.length == 0) {
        this.$message.error('请选择下单商品!');
        return false;
      }
      const _form = {
        cart_ids: this.productId ? '' : this.multipleSelection.map(item => item.id).join(','),
        product_id: this.productId ? this.productId : 0,
        address_id: this.addressId,
        model: this.model,
        group: this.group,
      };
      this.loading = true;
      addOrder(_form).then((res) => {
        this.loading = false;
        // 弹出操作提示
        if (res.data.pay_amount > 0) {
          this.$message.success('下单成功，正在为您跳转。。。');
          this.$router.push({
            path: '/cashier',
            query: {
              order_id: res.data.id,
              type: 0,
            }
          });
        } else {
          this.$message.success('下单成功，请等待工程师为您报价!'), setTimeout(() => {
            this.$router.push({
              path: '/user/order/list/store'
            });
          }, 1000);
        }

      }).catch(() => {
        this.loading = false;
      });

    },
    getAllCartList() {
      getAllCartList({}).then(res => {
        this.cartList = res.data;
      }).catch((err) => {
        this.loading = false;
      });
    },
    getAddressList() {
      getAllAddressList({}).then(res => {
        this.addressList = res.data;
        this.addressId = res.data.length > 0 ? res.data[0].id : 0;
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
      });
    },
    //从购物车移除
    handleDelete(row) {
      this.$confirm('是否删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        deleteCart({
          id: row.id
        }).then((response) => {
          this.loading = false;
          this.getAllCartList();
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.loading = false;
        });
      })
    },
    handleShowAddAddress() {
      this.showAddAddressForm = true;
    },
    getIndex() {
      getIndex({}).then((res) => {
        this.loading = false;
        this.user = res.data;
      }).catch((err) => {
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.store-cart-wrap {
  width: 100%;
  padding-top: 34px;
  padding-bottom: 75px;
  box-sizing: border-box;
  background-color: #f4f8f9;
  display: flex;
  align-items: center;
  flex-direction: column;

  .content-wrap {
    width: 1200px;
    display: flex;
    align-items: center;
    flex-direction: column;

    .my-breadcrumb {
      width: 100%;
    }

    .cart-card {
      width: 100%;
      margin-top: 15px;
      background: #ffffff;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.0196);
      padding: 30px 15px 71px 15px;
      box-sizing: border-box;

      .my-step {
        width: 100%;
        justify-content: center;
      }

      .active-step {
        display: block !important;
      }

      .step1 {

        width: 100%;

        .table-wrap {
          width: 100%;
          margin-top: 35px;

          .empty {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
          }

        }

        .total-wrap {
          width: 100%;
          font-size: 20px;
          font-weight: 400;
          color: #222222;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin-top: 41px;

          i {
            color: #ff6666;
          }

          .price {
            font-size: 32px;
            font-weight: bold;
            color: #ff6666;
          }

          .my-btn {
            padding: 11px 67px;
            font-size: 13px;
            font-weight: 300;
            color: #ffffff;
            margin-left: 42px;
          }
        }

        .order-tip-card {
          width: 100%;
          padding: 30px 15px 0 15px;
          box-sizing: border-box;
          border-top: 1px solid #ccd7db;
          background: #ffffff;
          margin-top: 100px;

          .title {
            font-size: 20px;
            font-weight: bold;
            color: #6f7f84;
          }

          .tip {
            font-size: 16px;
            font-weight: 400;
            color: #6f7f84;
            line-height: 30px;
            margin-top: 16px;
          }
        }
      }

      .step2 {
        width: 100%;
        margin-top: 35px;


        .address {
          width: 100%;
          padding: 25px 28px 64px 0px;
          box-sizing: border-box;

          &>.title {
            font-size: 20px;
            font-weight: 400;
            color: #6F7F84;
          }

          .address-list {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 0 280px;
            box-sizing: border-box;
            margin-top: 27px;
            row-gap: 20px;

            .item {
              width: 100%;
              display: flex;
              align-items: center;
              column-gap: 10px;
              font-size: 14px;
              font-weight: 300;
              color: #333333;
              margin-top: 10px;
            }
          }

          .addAddress {
            margin-top: 20px;
            margin-left: 280px;
            font-size: 14px;
            font-weight: 300;
            color: #00B4E8;
            cursor: pointer;
          }
        }

        .order-table {
          width: 100%;
          border-top: 1px solid #ccd7db;
          padding-top: 58px;

          .title {
            font-size: 20px;
            font-weight: 400;
            color: #6f7f84;
            margin-bottom: 15px;
          }
        }

        .action-btn {
          margin-top: 20px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          column-gap: 20px;

          .per-btn {
            font-size: 13px;
            font-weight: 300;
            color: #00b4e8;
            padding: 10px 48px;
            border-radius: 20px;
            border: 1px solid #00b4e8;
            background-color: #ffffff;
          }

          .submit-btn {
            font-size: 13px;
            font-weight: 300;
            color: #ffffff;
            padding: 10px 54px;
            background: #00b4e8;
            border-radius: 20px;
          }
        }
      }
    }
  }
}
</style>
